import { Tag } from '@wix/design-system'
import React, { FC } from 'react'

import { wixMobileCategorySuggestionsDataHooks } from './WixMobileCategorySuggestions.dataHooks'
import s from './WixMobileCategorySuggestions.scss'

export type SuggestionContent = {
  label: string
}

interface WixMobileCategorySuggestionsProps {
  suggestions: SuggestionContent[]
  onSuggestionClick: (suggestion: string, index: number) => void
  dataHook?: string
}

export const WixMobileCategorySuggestions: FC<WixMobileCategorySuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
  dataHook,
}) => {
  return (
    <div className={s.container} data-hook={dataHook}>
      {suggestions.map((suggestion, index) => (
        <Tag
          key={suggestion.label}
          id={suggestion.label}
          onClick={() => onSuggestionClick(suggestion.label, index)}
          size="medium"
          removable={false}
          className={s.item}
          dataHook={wixMobileCategorySuggestionsDataHooks.suggestion({ key: suggestion.label })}
        >
          {suggestion.label}
        </Tag>
      ))}
    </div>
  )
}
